import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import colors from "../../config/colors";
import { colorPalette } from "../../config/colorPalette";
import {
  controlBaseSx,
  focusRingSx,
  hiddenInputSx,
  rowSx,
} from "../_shared/controlStyles";

const markSx = (size) => ({
  fontSize: size,
  stroke: "currentColor",
  strokeWidth: 1,
});

/**
 * Checkbox
 *
 * Props:
 * - children: label
 * - indeterminate: shows the dash (a checked checkbox with indeterminate shows the dash)
 * - disabled, checked, defaultChecked, onChange, name, value: go to the native input
 * - sx: extra styles for the label row, merged last
 */
const Checkbox = ({
  children,
  indeterminate = false,
  disabled = false,
  sx: sxOverride = {},
  ...rest
}) => (
  <Box component="label" sx={{ ...rowSx(disabled), ...sxOverride }}>
    <Box
      component="input"
      type="checkbox"
      disabled={disabled}
      ref={(el) => {
        if (el) el.indeterminate = indeterminate;
      }}
      {...rest}
      sx={hiddenInputSx}
    />
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        ...controlBaseSx,
        width: 20,
        height: 20,
        borderRadius: "4px",
        backgroundColor: colors.white,
        border: `2px solid ${colorPalette.mercuryAlpha[18]}`,
        color: colors.white,
        "& svg": { display: "none" },
        "input:checked + &, input:indeterminate + &": {
          backgroundColor: colorPalette.brand[700],
          border: "none",
        },
        "input:checked + & .check": { display: "block" },
        "input:indeterminate + & .check": { display: "none" },
        "input:indeterminate + & .dash": { display: "block" },
        "input:disabled + &": {
          backgroundColor: colorPalette.mercuryAlpha[5],
          border: `2px solid ${colorPalette.mercuryAlpha[8]}`,
          color: colorPalette.mercuryAlpha[28],
        },
        "input:focus-visible + &": focusRingSx,
      }}
    >
      {/* larger, with a thin stroke added so the MUI glyphs read as solid as Figma's */}
      <CheckIcon className="check" sx={markSx(18)} />
      <RemoveIcon className="dash" sx={markSx(20)} />
    </Box>
    {children}
  </Box>
);

export default Checkbox;
